import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/default-avatar.svg'


const _withScopeId = n => (_pushScopeId("data-v-15306376"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lg:hidden"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/avatar.svg",
  alt: "",
  style: {"width":"45px","height":"45px"}
}, null, -1))
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  class: "overflow-hidden",
  style: {"max-width":"160px"}
}
const _hoisted_5 = { class: "font-medium mb-2 truncate" }
const _hoisted_6 = { class: "flex text-gray-description items-center text-sm mb-2 space-x-1 cursor-pointer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Central wallet ")
const _hoisted_8 = {
  key: 0,
  class: "-ml-14 mt-4 font-medium"
}
const _hoisted_9 = { class: "menu__item item--row hoverable" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My account", -1))
const _hoisted_11 = {
  class: "menu__item hoverable",
  style: {"margin-top":"10px"}
}
const _hoisted_12 = { class: "item--row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Donate", -1))
const _hoisted_14 = { class: "max-w-md" }
const _hoisted_15 = { class: "menu__item" }
const _hoisted_16 = { class: "responsive-flex sm:items-start sm:space-x-2 overflow-hidden" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-11 rounded-full shadow mb-2",
  alt: "default-avatar"
}, null, -1))
const _hoisted_18 = { class: "overflow-hidden" }
const _hoisted_19 = { class: "font-medium mb-2 break-words" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Central wallet ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_22 = { class: "menu__item item--row hoverable" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My account", -1))
const _hoisted_24 = {
  key: 1,
  class: "lg:hidden"
}
const _hoisted_25 = { class: "menu__item hoverable" }
const _hoisted_26 = { class: "item--row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Your contribution", -1))
const _hoisted_28 = { class: "menu__item hoverable" }
const _hoisted_29 = { class: "item--row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "History", -1))
const _hoisted_31 = { class: "menu__item hoverable" }
const _hoisted_32 = { class: "item--row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Receive NFTs", -1))
const _hoisted_34 = { class: "menu__item hoverable" }
const _hoisted_35 = { class: "item--row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Receive tokens", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_38 = { class: "menu__item hoverable" }
const _hoisted_39 = { class: "item--row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Donate", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_42 = { class: "item--row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Logout", -1))
const _hoisted_44 = { class: "my-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-xl font-semibold" }, "Logout", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-6 text-center text-lg" }, " Are you sure you want to logout? ", -1))
const _hoisted_47 = { class: "flex justify-center space-x-4" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Logout ")

import { Icon } from '@iconify/vue';
import { useUserStore } from '@/store/user';

import { useRouter } from 'vue-router';
import useCopyToClipboard from '@/composables/useCopyToClipboard';
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  props: {
    withDashboard: { type: Boolean },
    sidebar: { type: Boolean }
  },
  setup(__props: any) {



const router = useRouter();
const userStore = useUserStore();
const { copyToClipboard } = useCopyToClipboard();
const isSidebarOpen = ref<boolean>(false);

const isShowConfirmLogout = ref();
const logout = async () => {
  isShowConfirmLogout.value = true;
};
const logoutConfirm = async () => {
  isShowConfirmLogout.value = false;
  await userStore.logout();
  router.push('/landing');
};
const logoutCancel = () => {
  isShowConfirmLogout.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseMasked = _resolveComponent("BaseMasked")!
  const _component_BaseBadge = _resolveComponent("BaseBadge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VDropdown, {
      "popper-hide-triggers": ['click'],
      theme: "no-arrow",
      placement: "bottom-end"
    }, _createSlots({
      default: _withCtx(() => [
        (!__props.withDashboard && !__props.sidebar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_BaseButton, { secondary: "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    class: "text-white text-4xl",
                    icon: "charm:menu-hamburger"
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["cursor-pointer space-x-3 px-2", 
          __props.withDashboard && __props.sidebar ? 'flex' : 'hidden lg:flex items-center'
        ])
        }, [
          _hoisted_2,
          (_unref(userStore).ethAddress && !__props.sidebar)
            ? (_openBlock(), _createBlock(_component_BaseMasked, {
                key: 0,
                is: "p",
                class: "text-white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(userStore).email || _unref(userStore).ethAddress), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(userStore).ethAddress && __props.sidebar)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isSidebarOpen.value = !isSidebarOpen.value))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userStore).email), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_BaseMasked, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(userStore).ethAddress), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Icon), {
                        icon: "ci:copy",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copyToClipboard)(_unref(userStore).ethAddress)))
                      })
                    ]),
                    (_unref(userStore).isGeneratedUser)
                      ? (_openBlock(), _createBlock(_component_BaseBadge, { key: 0 }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_unref(Icon), {
                    icon: "akar-icons:chevron-down",
                    class: "text-xl"
                  })
                ]),
                (isSidebarOpen.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (__props.withDashboard)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/app"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_unref(Icon), {
                                  class: "text-xl",
                                  icon: "ri:dashboard-3-line"
                                }),
                                _hoisted_10
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_router_link, {
                          to: "/donate",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_unref(Icon), {
                                class: "text-xl",
                                icon: "akar-icons:coin"
                              }),
                              _hoisted_13
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 2
    }, [
      (!__props.sidebar)
        ? {
            name: "popper",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(userStore).email), 1),
                      _createElementVNode("div", {
                        class: "flex text-gray-description items-center text-sm mb-2 space-x-1 cursor-pointer",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(copyToClipboard)(_unref(userStore).ethAddress)))
                      }, [
                        _createVNode(_component_BaseMasked, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(userStore).ethAddress), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Icon), { icon: "ci:copy" })
                      ]),
                      (_unref(userStore).isGeneratedUser)
                        ? (_openBlock(), _createBlock(_component_BaseBadge, { key: 0 }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _hoisted_21,
                (__props.withDashboard)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/app"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_unref(Icon), { icon: "ri:dashboard-3-line" }),
                          _hoisted_23
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        class: "block",
                        to: "/app/inventory"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_unref(Icon), { icon: "uil:user-square" }),
                              _hoisted_27
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        class: "block",
                        to: "/app/activity"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_unref(Icon), { icon: "bx:bx-time" }),
                              _hoisted_30
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        class: "block",
                        to: "/app/receive-nft"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_unref(Icon), { icon: "material-symbols:generating-tokens-outline" }),
                              _hoisted_33
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        class: "block",
                        to: "/app/claim"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_unref(Icon), { icon: "fluent:ribbon-32-regular" }),
                              _hoisted_36
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _hoisted_37
                    ])),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_router_link, {
                    to: "/donate",
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_unref(Icon), { icon: "akar-icons:coin" }),
                        _hoisted_40
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_41,
                _createElementVNode("div", {
                  class: "menu__item hoverable",
                  onClick: logout
                }, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_unref(Icon), { icon: "ic:round-logout" }),
                    _hoisted_43
                  ])
                ])
              ])
            ])
          }
        : undefined
    ]), 1024),
    _createVNode(_component_BaseModal, {
      modelValue: isShowConfirmLogout.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShowConfirmLogout).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_BaseButton, {
              "color-scheme": "white",
              onClick: logoutCancel
            }, {
              default: _withCtx(() => [
                _hoisted_48
              ]),
              _: 1
            }),
            _createVNode(_component_BaseButton, {
              "color-scheme": "primary",
              onClick: logoutConfirm
            }, {
              default: _withCtx(() => [
                _hoisted_49
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})